import { defineComponent as _defineComponent } from 'vue'
import { waitUntil } from 'async-wait-until';
import { computed } from 'vue';
import { useRouter } from 'vue-router/composables';

import { Modes } from '@/common.js';
import { useBilling } from '@/components/Billing/Billing.composables';
import WorkspaceSelectionMenuWrapper from '@/components/WorkspaceSelectionMenu/WorkspaceSelectionMenuWrapper.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { GETTING_STARTED_ROUTE_NAME, CUSTOMIZE_PLAN_ROUTE_NAME } from '@/router/router.const';
import IntercomService from '@/utils/IntercomService';
// @ts-ignore
import InAppInjectables from '@/views/common/InAppInjectables';


export default /*#__PURE__*/_defineComponent({
  __name: 'BillingBetaPlansAccessDenied',
  setup(__props) {

const router = useRouter();
const { requestBetaPlansExtension, account, user } = useBilling();

const owner = computed(() => account.value?.owner);
const isOwner = computed(() => owner.value?.id === user.value?.id);

const logout = () => router.push({ name: 'logout' });

const createNewWorkspace = async () => {
	await AppDialogManagerService.openCreateWorkspaceDialog();
	router.push({ name: GETTING_STARTED_ROUTE_NAME });
};
const requestExtendBeta = async () => {
	await requestBetaPlansExtension();
	router.push({ name: CUSTOMIZE_PLAN_ROUTE_NAME });
};

const waitForIntercom = async () => {
	if (process.env.NODE_ENV === Modes.Production) {
		await waitUntil(() => IntercomService.loaded() && IntercomService.booted(), { timeout: 10000 });
		IntercomService.update({ alignment: 'right' }, false);
	}
};
waitForIntercom();

return { __sfc: true,router, requestBetaPlansExtension, account, user, owner, isOwner, logout, createNewWorkspace, requestExtendBeta, waitForIntercom, WorkspaceSelectionMenuWrapper, InAppInjectables }
}

})